import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';

// Shared by declaration and payment-obligation details. Keep keyboard focus
// within the modal and restore the exact initiating control on close.
export default function ReviewDrawer({title, onClose, children}) {
  const panel = useRef(null);
  const close = useRef(onClose); close.current = onClose;
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.current?.focus();
    const keyboard = event => {
      if (event.key === 'Escape') {event.preventDefault(); close.current();}
      if (event.key !== 'Tab') return;
      const focusable = [...panel.current.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),summary,[tabindex="0"]')].filter(el => el.getClientRects().length > 0);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) {event.preventDefault(); panel.current.focus();}
      else if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) {event.preventDefault(); last.focus();}
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel.current)) {event.preventDefault(); first.focus();}
    };
    document.addEventListener('keydown', keyboard);
    return () => {document.body.style.overflow = previousOverflow; document.removeEventListener('keydown', keyboard); if (previousFocus?.isConnected) previousFocus.focus();};
  }, []);
  return createPortal(<div className="me-review-overlay" onMouseDown={e => {if(e.target === e.currentTarget)onClose();}}>
    <aside className="month-end me-review-drawer" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} ref={panel}>
      <header><h2>{title}</h2><button type="button" onClick={onClose} aria-label="Fermer les détails">Fermer ×</button></header>
      {children}
    </aside>
  </div>, document.body);
}

export function ReviewTabs({value,onChange}) {
 const tabs=[['info','Informations générales'],['results','Résultats détaillés'],['anomalies','Anomalies et observations'],['documents','Documents et justificatifs'],['history','Historique des opérations']];
 return <nav className="me-review-tabs" role="tablist" aria-label="Détails de l’enregistrement">{tabs.map(([key,label])=><button type="button" role="tab" aria-selected={value===key} key={key} onClick={()=>onChange(key)}>{label}</button>)}</nav>;
}
